import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface PortalRouteProps {
  children: React.ReactNode;
}

const PortalRoute: React.FC<PortalRouteProps> = ({ children }) => {
  const { user, perfil, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }

  if (perfil?.rol !== 'cliente_portal') {
    // Usuario interno intentando entrar al portal → enviar al dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default PortalRoute;
